
import React, { useRef } from 'react';
import { User } from 'firebase/auth';
import { GoogleIcon } from './icons/GoogleIcon';

interface HeaderProps {
  user: User | null;
  isAdmin: boolean;
  onSignIn: () => void;
  onSignOut: () => void;
  onExport: () => void;
  onImport: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onAdminSignIn: () => void;
}

const Header: React.FC<HeaderProps> = ({ user, isAdmin, onSignIn, onSignOut, onExport, onImport, onAdminSignIn }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleImportClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <header className="bg-white/30 backdrop-blur-lg shadow-md sticky top-0 z-30">
      <div className="w-full px-4 md:px-8 py-3">
        <div className="flex justify-between items-center">
          <h1 className="text-xl md:text-2xl font-bold text-light">🚀 Mission Board</h1>
          <div className="flex items-center space-x-2 md:space-x-4">
            {user ? (
              // --- Logged-in User View ---
              <>
                <button onClick={onExport} className="text-sm md:text-base text-gray-700 hover:text-gray-900">Export</button>
                {isAdmin && (
                  <>
                    <button onClick={handleImportClick} className="text-sm md:text-base text-gray-700 hover:text-gray-900">Import</button>
                    <input type="file" accept=".json" ref={fileInputRef} onChange={onImport} className="hidden" />
                  </>
                )}
                <div className="flex items-center space-x-3">
                  <span className="hidden md:inline text-sm text-gray-600">|</span>
                  <img src={user.photoURL || undefined} alt={user.displayName || 'User'} className="w-8 h-8 rounded-full" />
                  <span className="hidden lg:inline font-medium text-gray-800">{user.displayName}</span>
                  <button onClick={onSignOut} className="text-sm text-red-500 hover:text-red-700 font-semibold">Sign Out</button>
                </div>
              </>
            ) : (
              // --- Guest View ---
              <>
                <button onClick={onExport} className="text-sm md:text-base text-gray-700 hover:text-gray-900">Export</button>
                <span className="hidden md:inline text-sm text-gray-600">|</span>
                <button
                  onClick={onSignIn}
                  className="inline-flex items-center bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors duration-200"
                >
                  <GoogleIcon className="w-5 h-5 mr-2" />
                  Sign in with Google
                </button>
                <button
                  onClick={onAdminSignIn}
                  className="inline-flex items-center bg-red-500 border border-red-700 rounded-lg px-4 py-2 text-sm font-medium text-white hover:bg-red-600 transition-colors duration-200"
                >
                  ADMIN
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
